import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination, Scrollbar, Navigation } from "swiper";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

import "./CertifCard.css";

const CertifCard = (props) => {
	return (
		<div className="tab-content">
			{props.tab.map((tab, key) => (
				<div className={`tab-pane ${key === 0 ? "active show" : ""}`} id={tab.tabLink} key={key}>
					<Swiper
						spaceBetween={30}
						centeredSlides={true}
						autoplay={{
							delay: 4000,
							disableOnInteraction: false,
						}}
						navigation={true}
						pagination={{
							clickable: true,
						}}
						modules={[Autoplay, Pagination, Scrollbar, Navigation]}
						className="mySwiper"
					>
						{props.data.map((data, key) => {
							if (data.category === tab.tabLink) {
								return (
									<SwiperSlide key={key}>
										<div className="row p-2">
											<div className="col-md-6 col-sm-12 order-2 order-md-1 left-content">
												<h3 className="title-certif">{data.title}</h3>
												<h5 className="company">{data.publisher}</h5>
												<p className="time">{`${data.startDate} - ${data.endDate}`}</p>
												<a href={data.link} className="blue credentials">
													See Credentials
												</a>
											</div>
											<div className="col-md-6 col-sm-12 order-1 order-md-2 right-content">
												<img src={data.image} className="card-img-top" alt="..." />
											</div>
										</div>
									</SwiperSlide>
								);
							}
						})}
					</Swiper>
				</div>
			))}
		</div>
	);
};

export default CertifCard;
